import { RootState } from 'editor/src/store/index';

const getFormatsData = (state: RootState) => state.editorModules.formats.selectors;

export default getFormatsData;
